import { presence } from '@imcc/utilities';

export class FilePath {
  constructor(private path: string) {}

  /**
   * Obtain the file name excluding extension.
   *
   * @Example
   *
   *   FilePath.fileName('images/pizza.jpg')
   *   //=> 'pizza'
   */
  static fileName = (path: string) => new FilePath(path).fileName;

  /**
   * Obtain the base name, i.e. the file name including extension.
   *
   * @Example
   *
   *   FilePath.baseName('images/pizza.jpg')
   *   //=> 'pizza.jpg'
   */
  static baseName = (path: string) => new FilePath(path).baseName;

  /**
   * Obtain the full directory, excluding trailing slash.
   *
   * @Example
   *
   *   FilePath.directory("assets/images/pizza.jpg")
   *   //=> 'assets/images'
   */
  static directory = (path: string) => new FilePath(path).directory;

  /**
   * Obtain the file extension, excluding dot.
   *
   * @Example
   *
   *   FilePath.fileExtension("images/pizza.jpg")
   *   //=> 'jpg'
   */
  static fileExtension = (path: string) => new FilePath(path).fileExtension;

  get fileName(): string {
    return this.baseName.replace(new RegExp(`\\.${this.fileExtension}$`), '');
  }

  get baseName(): string {
    return this.path.replace(new RegExp(`^${this.directory}/`), '');
  }

  get directory(): string {
    return presence(this.path.substr(0, this.path.lastIndexOf('/'))) || '.';
  }

  get fileExtension(): string {
    const index = this.path.lastIndexOf('.');

    if (index >= 0) {
      return this.path.substr(index + 1);
    }

    return '';
  }
}
